var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 736v160h160l472.107-472.107-160-160L128 736zm755.413-435.413c16.64-16.64 16.64-43.734 0-60.374l-99.626-99.626c-16.64-16.64-43.734-16.64-60.374 0l-78.08 78.08 160 160 78.08-78.08z"
  })));
};
export default SvgEdit;